var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		'inp_field',
		{
			has_focus: _vm.hasFocus,
			has_value: _vm.hasValue,
			has_clear: _vm.clearable,
		} ]},[_c('input',_vm._g(_vm._b({ref:"inputRef",class:['inp', _vm.formClass, { inp_error: _vm.error, w100p: _vm.justify }]},'input',_vm.attrs,false),_vm.listeners)),(!_vm.readonly && !_vm.disabled && _vm.clearable && _vm.hasValue)?_c('button',{staticClass:"btn_reset",attrs:{"type":"button","tabindex":"-1"},on:{"click":_vm.clear}},[_c('span',{staticClass:"txt_hidden"},[_vm._v("값 지우기")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }